import { v4 as uuidv4 } from "uuid";
import bookImagePlaceholder from "@circle-react-shared/BuilderUI/Assets/icons/book_image_placeholder.png";
import calendarImagePlaceholder from "@circle-react-shared/BuilderUI/Assets/icons/calendar_image_placeholder.png";
import supportImagePlaceholder from "@circle-react-shared/BuilderUI/Assets/icons/support_image_placeholder.png";
import usersImagePlaceholder from "@circle-react-shared/BuilderUI/Assets/icons/users_image_placeholder.png";
import type { BaseBlock } from "@circle-react-shared/BuilderUI/DataModel.types";
import { createCardBlock } from "@circle-react-shared/BuilderUI/DefaultBlocks/utils/layoutBlockHelpers/cardBlockHelper";
import { createImageBlock } from "@circle-react-shared/BuilderUI/DefaultBlocks/utils/mediaBlockHelpers";
import {
  createButtonBlock,
  createH2Block,
  createPBlock,
} from "@circle-react-shared/BuilderUI/DefaultBlocks/utils/textBlocksHelpers";
import { getBorderRadiusOptions } from "@circle-react-shared/BuilderUI/utils/imgStyleHelpers";
import { getSizingOptions } from "@circle-react-shared/BuilderUI/utils/sizeStyleHelpers";
import { getBlockSecondaryStyleOptions } from "../../constants";
import placeholderImage from "./homepage_block_6_default_image.png";

const cards = [
  {
    image: {
      signedId: "",
      placeholder: usersImagePlaceholder,
    },
    h5Text: "Launch with confidence",
    pText:
      "Use a proven step-by-step framework to define your offer, deliver your first cohort, and scale sustainably—with clarity at every stage.",
  },
  {
    image: {
      signedId: "",
      placeholder: calendarImagePlaceholder,
    },
    h5Text: "Build for learner impact",
    pText:
      "Design outcome-driven experiences using professional templates and structured flows that guide students through meaningful transformation.",
  },
  {
    image: {
      signedId: "",
      placeholder: supportImagePlaceholder,
    },
    h5Text: "Streamline your delivery",
    pText:
      "Set up the systems that power your growth. From onboarding to content workflows, create a seamless experience—for you and your learners.",
  },
  {
    image: {
      signedId: "",
      placeholder: bookImagePlaceholder,
    },
    h5Text: "Position for scale",
    pText:
      "Package your program with precision. Learn how to align your offer with the right audience, pricing, and delivery model for long-term growth.",
  },
] as const;

export const defaultData: BaseBlock = {
  id: uuidv4(),
  type: "ProfessionalNetworkHomepageBlock6",
  props: {
    header: {
      prop: "children",
      type: "children",
      value: [
        createH2Block({
          text: "Designed for impact. Built to scale.",
        }),
        createPBlock({
          text: "This program integrates curriculum design, strategic delivery, and operational systems—so you can scale your expertise with confidence and focus on results that matter.",
        }),
      ],
    },
    content: {
      prop: "children",
      type: "children",
      value: [
        createImageBlock({
          signedId: "",
          placeholder: placeholderImage,
          styles: {
            borderRadius: getBorderRadiusOptions({
              defaultValue: {
                border_left_top_radius: 20,
                border_left_bottom_radius: 20,
                border_right_top_radius: 20,
                border_right_bottom_radius: 20,
              },
            }),
            sizing: getSizingOptions({
              defaultValue: {
                maxHeight: "none",
                maxWidth: "none",
                width: "100%",
                height: "100%",
                minHeight: "auto",
                minWidth: "auto",
              },
            }),
          },
        }),
      ],
    },
    cards: {
      prop: "children",
      type: "children",
      value: cards.map(card => createCardBlock(card)),
    },
    footer: {
      prop: "children",
      type: "children",
      value: [
        createButtonBlock({
          text: "Enroll Now",
          href: "#",
        }),
        createPBlock({
          text: "Limited spots available. Applications close at the end of the month.",
          paragraphStyle: "p3",
        }),
      ],
    },
    styles: {
      prop: "styles",
      type: "styles",
      value: {
        ...getBlockSecondaryStyleOptions(),
      },
    },
  },
};
